/* JapHunter, PSA Showcase: rail, filters, sort, scrubber, autoplay, tilt. No dependencies. */
(function () {
  'use strict';

  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var SDA = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()'));
  var reduced = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover: hover) and (pointer: fine)');
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  function num(el, name, fallback) {
    var v = parseFloat(getComputedStyle(el).getPropertyValue(name));
    return isNaN(v) ? fallback : v;
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function Showcase(root) {
    this.root = root;
    this.rail = root.querySelector('[data-jhx-rail]');
    if (!this.rail) return;
    this.all = Array.prototype.slice.call(this.rail.querySelectorAll('[data-jhx-item]'));
    if (!this.all.length) return;
    this.items = this.all.slice();
    this.prevBtn = root.querySelector('[data-jhx-prev]');
    this.nextBtn = root.querySelector('[data-jhx-next]');
    this.track = root.querySelector('[data-jhx-track]');
    this.thumb = root.querySelector('[data-jhx-thumb]');
    this.cur = root.querySelector('[data-jhx-cur]');
    this.total = root.querySelector('[data-jhx-total]');
    this.playBtn = root.querySelector('[data-jhx-play]');
    this.sortSel = root.querySelector('[data-jhx-sort]');
    this.chipsBox = root.querySelector('[data-jhx-chips]');

    this.curve = root.dataset.curve !== 'false';
    this.jsCurve = this.curve && !SDA;
    this.playing = root.dataset.autoplay === 'true' && !reduced.matches;
    this.ms = Math.max(1500, parseInt(root.dataset.ms, 10) || 3250);
    this.group = '*';
    this.mode = 'o';
    this.idx = -1;
    this.inView = false;
    this.hover = false;
    this.focus = false;
    this.dragging = false;
    this.holdUntil = 0;
    this.offs = [];

    if (!this.playing && this.playBtn) root.classList.add('is-paused');
    this.buildChips();
    this.measure();
    this.jumpTo(this.startIndex(), false);
    this.update(true);
    this.settle();
    this.bind();
    this.observe();
    this.schedule();
    root.classList.add('is-ready');
  }

  var P = Showcase.prototype;

  P.on = function (el, type, fn, opts) {
    el.addEventListener(type, fn, opts || false);
    this.offs.push(function () { el.removeEventListener(type, fn, opts || false); });
  };

  P.destroy = function () {
    clearTimeout(this.timer);
    clearTimeout(this.settleT);
    if (this.io) this.io.disconnect();
    if (this.ro) this.ro.disconnect();
    this.offs.forEach(function (f) { f(); });
    this.offs = [];
  };

  /* ---------- geometry ---------- */
  P.measure = function () {
    var r = this.rail, it = this.items, root = this.root;
    this.viewW = r.clientWidth || 1;
    if (it.length > 1) this.step = it[1].offsetLeft - it[0].offsetLeft;
    else if (it.length === 1) this.step = it[0].offsetWidth + num(root, '--jhx-gap', 20);
    if (!this.step || this.step < 20) this.step = 300;
    this.base = it.length ? it[0].offsetLeft + it[0].offsetWidth / 2 - this.viewW / 2 : 0;
    this.perView = Math.max(1, Math.floor(this.viewW / this.step));
    this.fx = this.step * num(root, '--jhx-fx-steps', 2.3);
    this.rot = num(root, '--jhx-rot', 22);
    this.min = num(root, '--jhx-min', 0.84);
    this.pull = num(root, '--jhx-pull', 7);
    this.fade = num(root, '--jhx-fade', 0.9);
    if (this.track && this.thumb) {
      this.trackW = this.track.clientWidth;
      var frac = it.length ? clamp((this.viewW / this.step) / it.length, 0, 1) : 1;
      this.thumbW = Math.max(28, Math.round(this.trackW * frac));
      this.thumb.style.width = this.thumbW + 'px';
    }
  };

  /* start with the rail filled on both sides on wide screens, at the first card on phones */
  P.startIndex = function () {
    var n = this.items.length;
    if (!n) return 0;
    var cap = this.perView >= 6 ? 3 : 2;
    return Math.min(n - 1, this.perView >= 3 ? Math.min(cap, Math.floor(this.perView / 2)) : 0);
  };

  P.posAt = function (i) { return this.base + i * this.step; };

  P.jumpTo = function (i, smooth) {
    var n = this.items.length;
    if (!n) return;
    i = clamp(i, 0, n - 1);
    var left = Math.round(this.posAt(i));
    if (smooth && !reduced.matches && this.rail.scrollTo) {
      this.rail.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      this.rail.scrollLeft = left;
    }
  };

  P.go = function (i) { this.jumpTo(i, true); };

  /* ---------- per-frame update ---------- */
  P.request = function () {
    var self = this;
    if (this.pending) return;
    this.pending = true;
    raf(function () { self.pending = false; self.update(false); });
  };

  P.update = function (force) {
    var r = this.rail, n = this.items.length;
    if (!n) return;
    var sl = r.scrollLeft;
    var pos = (sl - this.base) / this.step;
    var i = clamp(Math.round(pos), 0, n - 1);
    if (i !== this.idx || force) {
      this.idx = i;
      if (this.cur) this.cur.textContent = String(i + 1);
      if (this.prevBtn) this.prevBtn.disabled = i <= 0;
      if (this.nextBtn) this.nextBtn.disabled = i >= n - 1;
    }
    if (this.thumb) {
      var max = Math.max(1, r.scrollWidth - r.clientWidth);
      var x = clamp(sl / max, 0, 1) * Math.max(0, this.trackW - this.thumbW);
      this.thumb.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
    }
    if (this.jsCurve) this.curveJs(pos);
  };

  /* fallback for browsers without scroll-driven animations (same maths as the CSS) */
  P.curveJs = function (pos) {
    var it = this.items, n = it.length;
    var from = Math.max(0, Math.floor(pos) - 5), to = Math.min(n - 1, Math.ceil(pos) + 5);
    for (var k = from; k <= to; k++) {
      var t = clamp(((k - pos) * this.step) / this.fx, -1, 1);
      var a = Math.abs(t);
      var st = it[k].style;
      st.transform = 'perspective(1100px) translateX(' + (-t * this.pull).toFixed(2) + '%) rotateY(' +
        (-t * this.rot).toFixed(2) + 'deg) scale(' + (1 - a * (1 - this.min)).toFixed(4) + ')';
      st.opacity = (1 - a * (1 - this.fade)).toFixed(3);
    }
  };

  /* runs when scrolling stops: mark the centre card and let the light sweep it */
  P.settle = function () {
    var c = this.items[this.idx];
    if (!c || c === this.center) return;
    if (this.center) this.center.classList.remove('is-center', 'is-land');
    this.center = c;
    c.classList.add('is-center');
    if (!reduced.matches && !this.dealing) {
      c.classList.remove('is-land');
      void c.offsetWidth;
      c.classList.add('is-land');
    }
  };

  /* ---------- autoplay ---------- */
  P.schedule = function () {
    var self = this;
    clearTimeout(this.timer);
    if (!this.playing) return;
    this.timer = setTimeout(function () { self.tick(); }, this.ms);
  };

  P.canAdvance = function () {
    return this.playing && this.inView && !this.hover && !this.focus && !this.dragging &&
      !document.hidden && Date.now() >= this.holdUntil && this.items.length > 1;
  };

  P.tick = function () {
    if (this.canAdvance()) {
      var n = this.items.length;
      this.go(this.idx >= n - 1 ? 0 : this.idx + 1);
    }
    this.schedule();
  };

  P.hold = function (ms) {
    this.holdUntil = Date.now() + (ms || 7000);
    this.schedule();
  };

  P.setPlaying = function (on) {
    this.playing = !!on;
    this.root.classList.toggle('is-paused', !this.playing);
    if (this.playBtn) {
      this.playBtn.setAttribute('aria-label', this.playing ? this.playBtn.dataset.lPause : this.playBtn.dataset.lPlay);
    }
    if (this.playing) this.holdUntil = 0;
    this.schedule();
  };

  /* ---------- filters & sort ---------- */
  P.buildChips = function () {
    var box = this.chipsBox;
    if (!box) return;
    var counts = {}, labels = {}, order = [];
    this.all.forEach(function (li) {
      var g = li.dataset.g || 'other';
      if (!counts[g]) { counts[g] = 0; labels[g] = li.dataset.gl || g; order.push(g); }
      counts[g]++;
    });
    if (order.length < 2) return;
    var frag = document.createDocumentFragment();
    var make = function (key, label, count, pressed) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'jhx__chip';
      b.dataset.g = key;
      b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      var a = document.createElement('span'); a.textContent = label;
      var c = document.createElement('small'); c.textContent = count;
      b.appendChild(a); b.appendChild(c);
      return b;
    };
    frag.appendChild(make('*', this.root.dataset.all || 'All', this.all.length, true));
    order.forEach(function (g) { frag.appendChild(make(g, labels[g], counts[g], false)); });
    box.appendChild(frag);
    box.hidden = false;
    this.chipsFade();
  };

  /* fade the right edge of the chip row only when it actually overflows */
  P.chipsFade = function () {
    var box = this.chipsBox;
    if (!box || box.hidden) return;
    var more = box.scrollWidth - box.clientWidth - box.scrollLeft > 4;
    box.classList.toggle('is-overflowing', more);
  };

  P.apply = function () {
    var g = this.group, mode = this.mode, rail = this.rail;
    var keyFn = {
      o: function (li) { return +li.dataset.o; },
      pa: function (li) { return +li.dataset.p; },
      pd: function (li) { return -li.dataset.p; },
      n: function (li) { return -li.dataset.c; }
    }[mode] || function (li) { return +li.dataset.o; };
    var list = this.all.slice().sort(function (a, b) {
      return (keyFn(a) - keyFn(b)) || (+a.dataset.o - +b.dataset.o);
    });
    var vis = [], frag = document.createDocumentFragment();
    list.forEach(function (li) {
      var show = g === '*' || li.dataset.g === g;
      li.hidden = !show;
      li.classList.remove('is-center', 'is-land');
      if (show) vis.push(li);
      frag.appendChild(li);
    });
    rail.appendChild(frag);
    this.items = vis;
    this.center = null;
    if (this.total) this.total.textContent = String(vis.length);
    if (this.jsCurve) this.all.forEach(function (li) { li.style.transform = ''; li.style.opacity = ''; });
    this.measure();
    this.idx = -1;
    this.jumpTo(this.startIndex(), false);
    this.update(true);
    this.settle();
    this.hold(9000);
  };

  /* ---------- events ---------- */
  P.bind = function () {
    var self = this, r = this.rail, root = this.root;

    this.on(r, 'scroll', function () {
      self.request();
      clearTimeout(self.settleT);
      self.settleT = setTimeout(function () { self.settle(); }, 140);
    }, { passive: true });
    if ('onscrollend' in window) {
      this.on(r, 'scrollend', function () { clearTimeout(self.settleT); self.update(false); self.settle(); });
    }

    if (window.ResizeObserver) {
      var lastW = r.clientWidth;
      this.ro = new ResizeObserver(function () {
        if (r.clientWidth === lastW) return;
        lastW = r.clientWidth;
        var keep = self.idx < 0 ? self.startIndex() : self.idx;
        self.measure();
        self.jumpTo(keep, false);
        self.update(true);
        self.chipsFade();
      });
      this.ro.observe(r);
    }
    if (this.chipsBox) this.on(this.chipsBox, 'scroll', function () { self.chipsFade(); }, { passive: true });

    var jump = function () { return self.perView >= 3 ? self.perView - 1 : 1; };
    if (this.prevBtn) this.on(this.prevBtn, 'click', function () { self.hold(9000); self.go(self.idx - jump()); });
    if (this.nextBtn) this.on(this.nextBtn, 'click', function () { self.hold(9000); self.go(self.idx + jump()); });

    if (this.playBtn) this.on(this.playBtn, 'click', function () { self.setPlaying(!self.playing); });

    if (this.sortSel) this.on(this.sortSel, 'change', function () { self.mode = self.sortSel.value; self.apply(); });
    if (this.chipsBox) this.on(this.chipsBox, 'click', function (e) {
      var b = e.target.closest ? e.target.closest('.jhx__chip') : null;
      if (!b || b.getAttribute('aria-pressed') === 'true') return;
      Array.prototype.forEach.call(self.chipsBox.querySelectorAll('.jhx__chip'), function (c) {
        c.setAttribute('aria-pressed', c === b ? 'true' : 'false');
      });
      self.group = b.dataset.g;
      self.apply();
    });

    /* pause autoplay while the visitor is interacting */
    var stage = root.querySelector('.jhx__stage') || r;
    this.on(stage, 'mouseenter', function () { self.hover = true; });
    this.on(stage, 'mouseleave', function () { self.hover = false; self.schedule(); });
    /* keyboard users browsing the cards keep control: no autoplay while focus is in the rail */
    this.on(r, 'focusin', function () { self.focus = true; });
    this.on(r, 'focusout', function (e) { if (!r.contains(e.relatedTarget)) { self.focus = false; self.schedule(); } });
    this.on(r, 'touchstart', function () { self.hold(8000); }, { passive: true });
    this.on(r, 'wheel', function () { self.hold(8000); }, { passive: true });
    this.on(document, 'visibilitychange', function () { self.schedule(); });

    this.bindDrag();
    this.bindTrack();
    this.bindTilt();
  };

  P.unsnapLater = function () {
    var self = this, r = this.rail, done = false;
    var finish = function () {
      if (done) return;
      done = true;
      r.removeEventListener('scrollend', finish);
      self.root.classList.remove('is-dragging', 'is-scrubbing');
      self.update(true);
      self.settle();
    };
    if ('onscrollend' in window) r.addEventListener('scrollend', finish);
    setTimeout(finish, 650);
  };

  /* mouse drag to scroll (touch and trackpads already scroll natively) */
  P.bindDrag = function () {
    var self = this, r = this.rail;
    var down = false, moved = false, sx = 0, ss = 0, lastX = 0, lastT = 0, v = 0, pid = null;
    this.on(r, 'pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = lastX = e.clientX; ss = r.scrollLeft; lastT = performance.now(); v = 0; pid = e.pointerId;
    });
    this.on(window, 'pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - sx;
      if (!moved) {
        if (Math.abs(dx) < 6) return;
        moved = true;
        self.dragging = true;
        self.root.classList.add('is-dragging');
        if (self.clearTilt) self.clearTilt();
      }
      var now = performance.now(), dt = now - lastT;
      if (dt > 0) v = 0.75 * v + 0.25 * ((e.clientX - lastX) / dt);
      lastX = e.clientX; lastT = now;
      r.scrollLeft = ss - dx;
    });
    var end = function (e) {
      if (!down || (e && e.pointerId !== pid)) return;
      down = false;
      if (!moved) return;
      self.dragging = false;
      var target = (r.scrollLeft - v * 220 - self.base) / self.step;
      self.jumpTo(Math.round(target), true);
      self.unsnapLater();
      self.hold(7000);
      var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      r.addEventListener('click', swallow, true);
      setTimeout(function () { r.removeEventListener('click', swallow, true); }, 0);
    };
    this.on(window, 'pointerup', end);
    this.on(window, 'pointercancel', end);
    this.on(r, 'dragstart', function (e) { e.preventDefault(); });
  };

  /* progress bar: click to jump, drag the thumb to travel through the whole collection */
  P.bindTrack = function () {
    var self = this, t = this.track, r = this.rail;
    if (!t) return;
    this.on(t, 'pointerdown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      self.hold(9000);
      var rect = t.getBoundingClientRect();
      var onThumb = e.target === self.thumb;
      var grab = onThumb ? e.clientX - self.thumb.getBoundingClientRect().left : self.thumbW / 2;
      var max = r.scrollWidth - r.clientWidth;
      var toScroll = function (x) {
        return clamp((x - rect.left - grab) / Math.max(1, rect.width - self.thumbW), 0, 1) * max;
      };
      self.dragging = true;
      self.root.classList.add('is-dragging', 'is-scrubbing');
      try { t.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      if (!onThumb) r.scrollLeft = toScroll(e.clientX);
      var move = function (ev) { r.scrollLeft = toScroll(ev.clientX); };
      var up = function () {
        t.removeEventListener('pointermove', move);
        t.removeEventListener('pointerup', up);
        t.removeEventListener('pointercancel', up);
        self.dragging = false;
        self.jumpTo(Math.round((r.scrollLeft - self.base) / self.step), true);
        self.unsnapLater();
      };
      t.addEventListener('pointermove', move);
      t.addEventListener('pointerup', up);
      t.addEventListener('pointercancel', up);
    });
  };

  /* desktop: the slab tilts toward the cursor and catches the light */
  P.bindTilt = function () {
    if (this.root.dataset.tilt === 'false' || !fine.matches || reduced.matches) return;
    var self = this, r = this.rail, card = null, last = null, queued = false;
    var reset = function (c) {
      c.classList.remove('is-hover');
      ['--rx', '--ry', '--gx', '--gy'].forEach(function (p) { c.style.removeProperty(p); });
    };
    var apply = function () {
      queued = false;
      if (!card || !last) return;
      var b = card.getBoundingClientRect();
      var x = clamp((last.clientX - b.left) / b.width, 0, 1);
      var y = clamp((last.clientY - b.top) / b.height, 0, 1);
      var st = card.style;
      st.setProperty('--rx', ((0.5 - y) * 14).toFixed(2) + 'deg');
      st.setProperty('--ry', ((x - 0.5) * 16).toFixed(2) + 'deg');
      st.setProperty('--gx', (x * 100).toFixed(1) + '%');
      st.setProperty('--gy', (y * 100).toFixed(1) + '%');
    };
    this.on(r, 'pointermove', function (e) {
      if (e.pointerType !== 'mouse' || self.dragging) return;
      var c = e.target.closest ? e.target.closest('.jhx__card') : null;
      if (c !== card) {
        if (card) reset(card);
        card = c;
        if (card) card.classList.add('is-hover');
      }
      last = e;
      if (card && !queued) { queued = true; raf(apply); }
    });
    this.on(r, 'pointerleave', function () { if (card) reset(card); card = null; });
    this.clearTilt = function () { if (card) reset(card); card = null; };
  };

  /* autoplay only while visible; the first time the rail shows up, the cards are dealt in */
  P.observe = function () {
    var self = this, target = this.root.querySelector('.jhx__stage') || this.rail;
    if (!('IntersectionObserver' in window)) { this.inView = true; return; }
    var canDeal = !reduced.matches && target.getBoundingClientRect().top > window.innerHeight;
    if (canDeal) this.prepareDeal();
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        self.inView = en.isIntersecting;
        if (self.inView && self.dealReady) self.deal();
        if (self.inView) self.schedule();
      });
    }, { threshold: 0.35 });
    this.io.observe(target);
  };

  P.prepareDeal = function () {
    var from = Math.max(0, this.idx - 3), to = Math.min(this.items.length - 1, this.idx + 3);
    for (var k = from, d = 0; k <= to; k++, d++) {
      this.items[k].classList.add('is-deal');
      this.items[k].style.setProperty('--d', d);
    }
    this.root.classList.add('is-predeal');
    this.dealReady = true;
  };

  P.deal = function () {
    var self = this, root = this.root;
    this.dealReady = false;
    this.dealing = true;
    root.classList.add('is-dealing');
    root.classList.remove('is-predeal');
    this.holdUntil = Date.now() + 1800;
    setTimeout(function () {
      root.classList.remove('is-dealing');
      self.all.forEach(function (li) { li.classList.remove('is-deal'); li.style.removeProperty('--d'); });
      self.dealing = false;
      if (self.center) {
        var c = self.center;
        self.center = null;
        c.classList.remove('is-center');
      }
      self.settle();
      self.schedule();
    }, 1300);
  };

  /* ---------- boot ---------- */
  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-jhx]');
    Array.prototype.forEach.call(list, function (el) {
      if (!el.__jhx) el.__jhx = new Showcase(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-jhx]') : null;
    if (el && el.__jhx) { el.__jhx.destroy(); el.__jhx = null; }
  });
})();